function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { serviceCostModel, serviceModel } from "../../../../models";
import { inputBillingDataToModel } from "../../../../models/service-billing/setters";
import { inputCostDataToModel } from "../../../../models/service-cost";
const getServicesWithNewData = _ref => {
  let {
    serviceData,
    serviceId,
    services
  } = _ref;
  return services.map(s => s.id === serviceId ? _objectSpread(_objectSpread({}, s), serviceData) : s);
};
const getServicesBundlesWithNewData = _ref2 => {
  let {
    serviceId,
    serviceBundles,
    serviceData
  } = _ref2;
  return serviceBundles ? {
    bundles: serviceBundles.bundles.map(bundle => bundle.services.find(s => s.id === serviceId) ? _objectSpread(_objectSpread({}, bundle), {}, {
      services: getServicesWithNewData({
        serviceData,
        serviceId,
        services: bundle.services
      })
    }) : bundle)
  } : undefined;
};
export const getDraftServicesWithNewData = _ref3 => {
  let {
    serviceData,
    serviceId,
    draft
  } = _ref3;
  const bundles = draft.serviceBundles();
  return {
    serviceBundles: getServicesBundlesWithNewData({
      serviceData,
      serviceId,
      serviceBundles: bundles.length > 0 ? {
        bundles
      } : undefined
    }),
    services: getServicesWithNewData({
      serviceData,
      serviceId,
      services: draft.services()
    })
  };
};
export const getServiceName = _ref4 => {
  var _bundle$services$find, _draft$services$find;
  let {
    draft,
    serviceId
  } = _ref4;
  const bundle = draft.serviceBundles().find(b => b.services.find(s => s.id === serviceId));
  if (bundle) return ((_bundle$services$find = bundle.services.find(s => s.id === serviceId)) === null || _bundle$services$find === void 0 ? void 0 : _bundle$services$find.name) || '';
  return ((_draft$services$find = draft.services().find(s => s.id === serviceId)) === null || _draft$services$find === void 0 ? void 0 : _draft$services$find.name) || '';
};
export const billingFormToService = _ref5 => {
  let {
    service,
    billingForm
  } = _ref5;
  const {
    pricing,
    price,
    minPrice,
    unitCap,
    unitName
  } = billingForm;
  const priceIncrease = serviceModel.priceIncrease(service);
  const cost = inputCostDataToModel({
    pricing,
    price: +price,
    minPrice,
    discount: service.cost.discount,
    priceIncrease,
    unitCap,
    unitName
  });
  const billing = inputBillingDataToModel({
    billingForm,
    originalService: service
  });
  return _objectSpread(_objectSpread({}, service), {}, {
    cost,
    billing
  });
};
export const getPriceData = cost => {
  const discount = serviceCostModel.discount(cost);
  return {
    price: serviceCostModel.isRangePrice(cost) ? {
      minPrice: serviceModel.minPrice({
        cost
      }),
      maxPrice: serviceModel.price({
        cost
      })
    } : serviceModel.price({
      cost
    }),
    hasDiscount: discount != null && discount.amount().gt(0),
    discountedPrice: serviceCostModel.isRangePrice(cost) ? {
      minPrice: serviceModel.minPriceFinal({
        cost
      }),
      maxPrice: serviceModel.applyDiscount({
        cost
      })
    } : serviceModel.finalPrice({
      cost
    }, 1)
  };
};